import { Nullable } from '../../common/domain/types/types';

export type AttendanceConfigurationPrimitives = {
  mode: Nullable<AttendanceMode>;
};

export const AttendanceModes = {
  BASIC: 'basic',
  AUTH_AND_BASIC: 'auth_and_basic',
} as const;
export type AttendanceMode = typeof AttendanceModes[keyof typeof AttendanceModes];

export class AttendanceConfiguration {
  constructor(public readonly mode: Nullable<AttendanceMode>) {}

  static fromPrimitives(primitives: AttendanceConfigurationPrimitives): AttendanceConfiguration {
    if (!primitives) {
      return new this(null);
    }

    const mode = primitives?.mode ?? '';
    if (mode.trim() === '') {
      return new this(null);
    }

    return new this(mode as AttendanceMode);
  }

  toPrimitives(): AttendanceConfigurationPrimitives {
    return {
      mode: this.mode,
    };
  }

  isEnabled(): boolean {
    return this.mode !== null;
  }

  isBasic(): boolean {
    return this.mode === AttendanceModes.BASIC;
  }

  isAuthAndBasic(): boolean {
    return this.mode === AttendanceModes.AUTH_AND_BASIC;
  }
}
